<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
      </v-toolbar>

      <v-card-text style="padding: 20px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  label="Prefeitura:"
                  :rules="fieldRules"
                  :items="prefectures"
                  item-value="prefecture_id"
                  item-text="prefecture_social_name"
                  v-model="data.prefecture_id"
                  @change="[loadProviders(), loadSec(), getVehiclesByPrefecture()]"
                  :readonly="formDisable"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :items="providers"
                  item-value="provider_id"
                  item-text="provider_name"
                  label="Participante:"
                  :rules="fieldRules"
                  v-model="data.provider_id"
                  @change="[loadProvidersItem()]"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  v-model="data.vehicle_id"
                  label="Veículo"
                  :items="vehicles"
                  item-text="model_desc"
                  item-value="vehicle_id"
                >
                  <template slot="selection" slot-scope="{ item }"
                    >{{ item.brand_desc }} - {{ item.model_desc }} -
                      {{ item.vehicle_board }}</template
                  >
                  <template slot="item" slot-scope="{ item }"
                    >{{ item.brand_desc }} - {{ item.model_desc }} -
                      {{ item.vehicle_board }}</template
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Número NF:"
                  :rules="fieldRules"
                  v-model="data.nf_number"
                  v-mask-number
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field
                  label="Data de Emissão"
                  :rules="fieldRules"
                  v-model="data.nf_issue_date"
                  v-mask-date.br
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Nome Completo"
                  :rules="fieldRules"
                  v-model="data.nf_name"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :items="prefectures_sec"
                  item-value="sec_id"
                  item-text="sec_name"
                  label="Unidade Orçamentária:"
                  :rules="fieldRules"
                  v-model="data.nf_sec_id"
                  append-icon="mdi-plus"
                  @click:append="bidding_id ? $router.push(`/parts-and-services/biddings-manager/edit/${bidding_id}?tab=1`) : null"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :items="prefectures_sec"
                  item-value="sec_id"
                  item-text="sec_name"
                  label="Unidade Orçamentária Destinatário:"
                  :rules="fieldRules"
                  v-model="data.nf_sec_recipient_id"
                  append-icon="mdi-plus"
                  @click:append="bidding_id ? $router.push(`/parts-and-services/biddings-manager/edit/${bidding_id}?tab=1`) : null"
                />
              </v-col>
            </v-row>
            <div v-for="(item, i) in itens" :key="i">
              <v-row
                align="center"
                justify="center"
                :class="i == 0 ? 'mt-n5' : 'mt-n7'"
                v-if="item.isServico"
              >
                <v-col cols="8">
                  <v-text-field label="Serviço" v-model="item.servico" />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Preço"
                    v-model="item.preco"
                    v-mask-decimal.br="2"
                    prefix="R$"
                    @change="onChangeTotal()"
                  />
                </v-col>
                <v-col cols="1">
                  <v-btn @click="removeField(i)" small color="error"
                    >Excluir</v-btn
                  >
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="center"
                :class="i == 0 ? 'mt-n5' : 'mt-n7'"
                v-else
              >
                <v-col cols="5">
                  <v-autocomplete
                    label="Peça"
                    :items="providersItem"
                    item-value="item_id"
                    v-model="item.peca_id"
                  >
                    <template slot="item" slot-scope="{ item }">
                      <span>{{
                        `${item.name} - ${item.marca} - ${item.modelo} - ${item.origem}`
                      }}</span>
                    </template>
                    <template slot="selection" slot-scope="{ item }">
                      <span>{{
                        `${item.name} - ${item.marca} - ${item.modelo} - ${item.origem}`
                      }}</span>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Preço Unitário"
                    v-model="item.preco"
                    v-mask-decimal.br="2"
                    prefix="R$"
                    @change="onChangeParts(i)"
                  />
                </v-col>
                <v-col cols="1">
                  <v-text-field
                    label="Quantidade"
                    v-model="item.quantidade"
                    v-mask-number
                    @change="[onChangeParts(i), onChangeTotal()]"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    label="Total"
                    v-model="item.total"
                    v-mask-decimal.br="2"
                    prefix="R$"
                  />
                </v-col>
                <v-col cols="1">
                  <v-btn @click="removeField(i)" small color="error"
                    >Excluir</v-btn
                  >
                </v-col>
              </v-row>
            </div>
            <v-row align="center" justify="end">
              <v-btn @click="addFieldParts" class="primary mr-2" small
                >Adicionar Peça</v-btn
              >
              <v-btn @click="addFieldServices" class="primary mr-2" small
                >Adicionar Serviço</v-btn
              >
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  label="Desconto"
                  v-model="data.nf_discount"
                  v-mask-decimal.br="2"
                  prefix="R$"
                  @change="onChangeTotal()"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  label="Total"
                  v-model="data.nf_total"
                  :rules="fieldRules"
                  v-mask-decimal.br="2"
                  prefix="R$"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-footer style="padding: 10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
        >
          Confirmar
        </v-btn>
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      nf_id: null,
      nf_number: "",
      prefecture_id: null,
      provider_id: null,
      vehicle_id: null,
      nf_issue_date: "",
      nf_name: "",
      nf_sec_id: null,
      nf_sec_recipient_id: null,
      nf_item: null,
      nf_discount: "",
      nf_total: "",
    },
    prefectures: [],
    providers: [],
    providersItem: [],
    itens: [],
    vehicles: [],
    formDisable: false,
    prefectures_sec: [],
    bidding_id: null,
  }),
  created() {
    this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`/parts-and-services/nf/${this.id}`).then((r) => {
        this.data = r.data[0];
        delete this.data.created_at;
        this.loadProviders();
        this.loadSec();
        this.loadProvidersItem();
        this.getVehiclesByPrefecture();
        if (this.data.nf_issue_date) {
          this.data.nf_issue_date = this.formatDateBr(this.data.nf_issue_date);
        }
        this.itens = JSON.parse(this.data.nf_item);
        this.$store.dispatch("setLoader", false);
      });
    }
    if (this.$store.getters.getUserData.table_key == 'prefectures') {
      this.formDisable = true;
      this.data.prefecture_id = this.$store.getters.getUserData.table_id;
      this.loadProviders();
      this.loadSec();
    }
  },
  methods: {
    onChangeParts(i) {
      if (this.itens[i].preco && this.itens[i].quantidade) {
        const value = parseFloat(this.itens[i].preco.split(".").join("").replace(",", ".")) * parseInt(this.itens[i].quantidade, 10);
        this.itens[i].total = value.toFixed(2).toString().replace('.', ',');
      }
    },
    onChangeTotal() {
      let total = 0;
      this.itens.map((item) => {
        if (item.isServico && item.preco) {
          total += parseFloat(item.preco.split(".").join("").replace(",", "."));
        } else if (item.total) {
          total += parseFloat(item.total.split(".").join("").replace(",", "."));
        }
      });
      if (this.data.nf_discount) {
        total -= parseFloat(this.data.nf_discount.split(".").join("").replace(",", "."));
      }
      this.data.nf_total = total.toFixed(2).toString().replace('.', ',');
    },
    getVehiclesByPrefecture() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/vehicles/prefectures/${this.data.prefecture_id}`)
        .then((v) => {
          this.vehicles = v.data;
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    addFieldParts() {
      this.itens.push({
        peca_id: null,
        preco: "",
        quantidade: "",
        total: "",
        isServico: false,
      });
    },
    addFieldServices() {
      this.itens.push({
        servico: "",
        preco: "",
        isServico: true,
      });
    },
    removeField(index) {
      this.itens.splice(index, 1);
    },
    formatDateBr(date) {
      return date.substr(0, 10).split("-").reverse().join("/");
    },
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      this.data.nf_item = JSON.stringify(this.itens);
      if (this.data.nf_discount == "") {
        this.data.nf_discount = "0.00";
      } else {
        this.data.nf_discount = this.data.nf_discount
          .split(".")
          .join("")
          .replace(",", ".");
      }
      this.data.nf_total = this.data.nf_total
        .split(".")
        .join("")
        .replace(",", ".");
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/parts-and-services/nf/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.loader = true;

            if (r.data.result) {
              this.snack.message = r.data.result;
              this.snack.color = "success";
              setTimeout(() => {
                this.$router.push("/parts-and-services/nf");
              }, 1500);
              this.$store.dispatch("setLoader", this.loader);
            } else {
              this.snack.message = r.data.error;
              this.snack.color = "error";
              this.loader = false;
            }
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.data.itens = this.itens;
        this.$http
          .post("/parts-and-services/nf", this.data)
          .then((r) => {
            this.snack.show = true;
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            if (r.data.success) {
              this.snack.message = r.data.success;
              this.snack.color = "success";
              setTimeout(() => {
                this.$router.push("/parts-and-services/nf");
              }, 1500);
            } else {
              this.snack.message = r.data.error;
              this.snack.color = "error";
              this.loader = false;
            }
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
    loadProviders() {
      this.$http
        .get(
          `/parts-and-services/providers/prefecture/${this.data.prefecture_id}`
        )
        .then((r) => (this.providers = r.data));
    },
    loadProvidersItem() {
      this.$http
        .get(`/parts-and-services/nf/providers/${this.data.provider_id}`)
        .then((r) => {
          this.providersItem = r.data;
          this.bidding_id = r.data[0].bidding_id;
        });
    },
    loadSec() {
      this.$http
        .get(`/prefectures/secretariats/${this.data.prefecture_id}`)
        .then((r) => (this.prefectures_sec = r.data));
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
